module.exports = __webpack_public_path__ + "static/media/blog-post4.2ef42d70.jpg";